import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {Helper} from '../../../../helpers/helper.service';
import {environment} from '../../../../../environments/environment';
import {FileItem, FileLikeObject, FileUploader, ParsedResponseHeaders} from 'ng2-file-upload';
import {GeneralTermService} from '../../../Services/general-term.service';
import {AuthenticationService} from '../../../../shared/Services/authentication.service';
import {GeneralTerm} from '../../../Models/GeneralTerm';

const baseUri = environment.apiUrl;
const URL = baseUri + '/backoffice/file_manager?bupload=GeneralTerm.file';

@Component({
  selector: 'app-manage-general-term',
  templateUrl: './manage-general-term.component.html',
  styleUrls: ['./manage-general-term.component.scss']
})
export class ManageGeneralTermComponent implements OnInit {
  public generalTerm: GeneralTerm = new GeneralTerm();
  public classicBox;
  public enableSave = true;
  public termId: number;
  public isEdit = false;
  public model: any = {};
  public modules = {};
  public uploader: FileUploader = new FileUploader({
    itemAlias: 'file',
    url: URL,
    authToken: this.auth.getBearerHeader(),
    allowedMimeType: ['application/pdf'],
    allowedFileType: ['pdf']
  });
  public isUploading: boolean;
  private addFileItem: boolean;
  private isNotAdd = false;
  public isFileEdit = false;
  public imageFileName: string;
  public mimeTypeFail = false;
  private currentFileID;
  private target: any;

  constructor(
    private route: ActivatedRoute,
    public helper: Helper,
    private auth: AuthenticationService,
    private router: Router,
    private generalTermService: GeneralTermService
  ) {
  }


  ngOnInit() {
    this.uploader.onAfterAddingFile = (item => {
      if (this.target) {
        this.target.value = '';
      }
      item.withCredentials = false;
    });
    this.route.params.subscribe(params => {
      this.modules = {
        toolbar: [
          ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
          ['blockquote', 'code-block'],

          [{'header': 1}, {'header': 2}],               // custom button values
          [{'list': 'ordered'}, {'list': 'bullet'}],
          [{'script': 'sub'}, {'script': 'super'}],      // superscript/subscript
          [{'indent': '-1'}, {'indent': '+1'}],          // outdent/indent
          [{'direction': 'rtl'}],                         // text direction

          [{'size': ['small', false, 'large', 'huge']}],  // custom dropdown
          [{'header': [1, 2, 3, 4, 5, 6, false]}],

          [{'color': []}, {'background': []}],          // dropdown with defaults from theme
          [{'font': []}],
          [{'align': []}],

          ['clean'],                                         // remove formatting button

          ['link']                         // link and image, video
        ]
      };
      if (Helper.isDefined(params['id'])) {
        this.termId = params['id'];
        this.isEdit = true;
      }
    });
    if (this.isEdit) {
      this.generalTermService.getTerm(this.termId).subscribe((generalTerm: GeneralTerm) => {
        this.generalTerm = generalTerm;
        if (generalTerm.file) {
          this.imageFileName = generalTerm.file.filename;
          this.currentFileID = generalTerm.file.id;
          // @ts-ignore
          this.generalTerm.file = generalTerm.file.id;
          if (generalTerm.file.id) {
            this.isNotAdd = false;
          }
        }
      });
    }

  }

  enableButton(event) {

    this.enableSave = event;
  }

  submitItem(next: boolean) {
    if (next) {
      delete this.generalTerm.id;
      this.generalTermService.manageTerm(this.generalTerm, this.isEdit, this.termId).subscribe((resp) => {
        this.router.navigateByUrl('/back-office/terms/overview');
      });
    } else {
      this.router.navigateByUrl('/back-office/terms/overview');
    }

  }

  uploadFile(event) {
    this.isUploading = true;
    this.isNotAdd = true;
    if (event.srcElement) {
      event.srcElement.value = '';
      this.target = event.target || event.srcElement;
    }
    this.uploader.uploadAll();
    const target = event.target || event.srcElement;
    target.value = '';
    this.uploader.onErrorItem = (item: FileItem, response, status: number, headers: ParsedResponseHeaders) => {
      this.isUploading = false;
      const res = JSON.parse(response);
      this.helper.popMessageDialog(res.title, res.errors);
    };
    this.uploader.onSuccessItem = (item: FileItem, response: string, status: number, headers: ParsedResponseHeaders) => {
      if (response) {
        this.addFileItem = false;
        this.isUploading = false;
        this.isNotAdd = false;
        const res = JSON.parse(response);
        this.generalTerm.file = res.id;
        this.currentFileID = res.id;
        this.imageFileName = res.filename;
      }
    };
  }

  changeImage(event) {
    const element: HTMLElement = document.getElementById('uploaderFile') as HTMLElement;
    element.click();
  }
}
